import React, { useState, useEffect } from "react";
import BreadCrumb from "../BreadCrumb";
import Layout from "../Layout";
import { fetchDetails } from "../../redux/actions/dashboardAction";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../common/Loader";
import { Row, Col ,Form} from "react-bootstrap";
import * as Icon from "react-feather";
import ClassGroupOveview from "./ClassGroupOverview";
import './index.css'
import RevenueByGroup from "./RevenueByGroup";
import  StudentListYearLevel  from "./StudentsListYearLevel";
import nurseryGroup from '../../assets/images/student.png'
import playGroup from '../../assets/images/reading.png'
import JrKG from '../../assets/images/classroom.png'
import SrKG from '../../assets/images/student-bag.png'
import moment from "moment";
import { CLASS_GROUP, STUDENT } from "../constants";
import ReactSelect from 'react-select';
import { fetchBranchData, fetchYearsList } from "../../redux/actions/studentActions";
import { RECEPTIONIST } from "../../common/constants";
import { fetchBranchList } from "../../redux/actions/feesActions";
import { NavLink } from "react-router-dom";
const Dashboard = (props) => {
  const dispatch = useDispatch();
  const { yearsList } = useSelector((state) => state.student);
  const { details, loader } = useSelector((state) => state.dashboard);
  const { userDetails  } = useSelector((state) => state.user);
  const { branchList  }  = useSelector(state => state.fees)
  const [sideMenu, setSideMenu] = useState(true);
  const [year,setYear] = useState({
    value: moment().format("YYYY"),
    label: moment().format("YYYY")
  })
  const [BranchId, setBranchId] = useState(null);
  const [Branches, setBranches] = useState([]);
  const onSideMenu = (value) => {
    setSideMenu(value);
  };

  useEffect(() => {
    async function fetchDashboardDetails() {
      await  dispatch(fetchDetails({year: moment().format("YYYY")}));
      await  dispatch(fetchYearsList());
      await dispatch(fetchBranchList());
    }

    fetchDashboardDetails();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const data = branchList.map(obj=>{
      return {
        value: obj.id,
        label: obj.name
      }
    })
    setBranches(data);
  }, [branchList])
  
  const classGroupMapping = [{
    imgUrl: playGroup,
    style: {backgroundColor:"#36b7b2",color:"#fff"}
  },
  {
    imgUrl: nurseryGroup,
    style: {backgroundColor:"#1498cf",color:"#fff"}
  },
  {
    imgUrl: JrKG,
    style: {backgroundColor:"#f26189",color:"#fff"}
  },
  {
    imgUrl: SrKG,
    style: {backgroundColor:"#9a52a3",color:"#fff"}
  }]
const handleChange= async(data)=>{
  setYear(data)
  let reqParams = {year: data.value}
  if(BranchId){
    reqParams.BranchId = BranchId.value;
  }
  await  dispatch(fetchDetails(reqParams));
}
const handleBranchChange= async(data)=>{
  console.log(data)
  setBranchId(data)
  await  dispatch(fetchDetails({year: year.value, BranchId: data.value}));
}
  return (
    <div className="">
      <Layout onClick={onSideMenu} />
      <PageLoader loader={loader}>
        <div
          className={`main-content d-flex flex-column ${
            sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          <div className="main-content-header">
            <BreadCrumb />
          </div>
          <Row>
          <Form.Group
            className={`col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 required `}
            controlId="formFirstName" 
          >
            <Form.Label className="label">Please Select Year</Form.Label>
            <ReactSelect
                        // isClearable
                        options={yearsList}
                        value={year}
                        onChange={handleChange}
                      />
          </Form.Group>
          <Form.Group
            className={`col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3  `}
            controlId="formFirstName" 
          >
            <Form.Label className="label">Please Select Branch</Form.Label>
            <ReactSelect
                        // isClearable
                        placeholder={"Please Select Branch"}
                        options={Branches}
                        value={BranchId}
                        onChange={handleBranchChange}
                      />
          </Form.Group>
            </Row>
          <Row>

          { details && details.groupLevelStudents && details.groupLevelStudents.map((groupOb,groupIndex)=>(
              <>
                  {
                    groupIndex <= 3 ? (
                        <>
                        <Col sm={6} lg={3}>
                          <div className="stats-card  mb-4" style={classGroupMapping[groupIndex].style}>
                            <div className="row">
                            <div className="col-6">
                              <h3 >
                              {( groupOb.totalStudents || 0)}
                              <Icon.ArrowUpCircle className="icon" />
                            </h3>
                            <p style={{color:"#fff"}}>{groupOb.name} </p>
                                </div>
                                <div className="col-6">
                              <img src={classGroupMapping[groupIndex].imgUrl}  width="100px"/>
                              </div>
                            </div>
                            
                          </div>
                        </Col>
                        </>
                    ) :(
                      <>
                      <Col sm={6} lg={3}>
                        <div className="stats-card  mb-4" style={classGroupMapping[0].style}>
                          <div className="row">
                          <div className="col-6">
                            <h3 >
                            {( groupOb.totalStudents || 0)}
                            <Icon.ArrowUpCircle className="icon" />
                          </h3>
                          <p style={{color:"#fff"}}>{groupOb.name} </p>
                              </div>
                              <div className="col-6">
                            <img src={classGroupMapping[0].imgUrl}  width="100px"/>
                            </div>
                          </div>
                          
                        </div>
                      </Col>
                      </>
                    )
                  }
              </>
          ))}
          </Row>
            <div className="spacer"></div>
            
          <Row>
            <Col sm={6} lg={3}>
              <div className="stats-card purple-card mb-4">
                <h3>
                  { ( details.pendingRegistrationStudents || 0 )}
                  <Icon.ArrowUpCircle className="icon" />
                </h3>
                <p><NavLink to="/pendingRegistration">Pending Registration</NavLink></p>
                <i className="lni-users" />
              </div>
            </Col>
            <Col sm={6} lg={3}>
              <div className="stats-card light-blue-card mb-4">
                <h3>
                { ( details.totalStudents || 0 )}
                  <Icon.ArrowUpCircle className="icon" />
                </h3>
                <p><NavLink to="/studentsList">Total Students</NavLink></p>
                <i className="fa fa-users" />
              </div>
            </Col>
            {userDetails.role === RECEPTIONIST ? null : (
              <>
              <Col sm={6} lg={3}>
              <div className="stats-card success-card mb-4">
                <h3>
                &#8377; { details &&  details.paymentCompleted &&  ( details.paymentCompleted[0]['totalAmount'] || 0) }
                  <Icon.ArrowUpCircle className="icon" />
                </h3>
                <p><NavLink to="/paymentsList">Payments Completed</NavLink></p>
                <i className="lni-check-mark-circle" />
              </div>
            </Col>

            <Col sm={6} lg={3}>
              <div className="stats-card danger-card mb-4">
                <h3>
                &#8377; { details &&  details.paymentDue &&  (details.paymentDue[0]['totalAmount'] || 0) }
                  <Icon.ArrowDownCircle className="icon" />
                </h3>
                <p><NavLink to="/paymentDue">Pending Payment</NavLink></p>
                <i className="lni-reload" />
              </div>
            </Col>
              </>
            )}
            
          </Row>
          <div className="row">
                        <Col lg={12}>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <div className="card-header">
                                        <h5 className="card-title">Students Joined</h5>
                                    </div>
                                    {
                                      details && details.studentSeriesData && (
                                        <ClassGroupOveview studentData = {details.studentSeriesData}/>
                                      )
                                    }
                                    
                                </div>
                            </div>
                        </Col>
                    </div>
          <div className="row">
                        <Col lg={6}>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <div className="card-header">
                                        <h5 className="card-title">Students By Class Group</h5>
                                    </div>
                                    {
                                      details && details.groupLevelStudents && (
                                        <RevenueByGroup  studentData = {details.groupLevelStudents} type={STUDENT}/>
                                      )
                                    }

                                    
                                </div>
                            </div>
                        </Col>

                        <Col lg={6}>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <div className="card-header">
                                        <h5 className="card-title">Revenue By Class Group</h5>
                                    </div>
                                    {
                                      details && details.revenueByClassGroup && (
                                        <RevenueByGroup  studentData = {details.revenueByClassGroup} type={CLASS_GROUP}/>
                                      )
                                    }
                                </div>
                            </div>
                        </Col>
                    </div>
                    <div className="row">
                        <Col lg={12}>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <div className="card-header">
                                        <h5 className="card-title">Students List By Year</h5>
                                    </div>
                                    {
                                      details && details.studentCountYearLevel && (
                                        <StudentListYearLevel studentCountYearLevel={details.studentCountYearLevel}/>
                                      )
                                    }
                                    
                                </div>
                            </div>
                        </Col>
                    </div>
        </div>
      </PageLoader>
    </div>
  );
};

export default Dashboard;
